/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NewAttendUser.vue?vue&type=template&id=ab35bd98&scoped=true&"
import script from "./NewAttendUser.vue?vue&type=script&lang=js&"
export * from "./NewAttendUser.vue?vue&type=script&lang=js&"
import style0 from "./NewAttendUser.vue?vue&type=style&index=0&id=ab35bd98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35bd98",
  null
  
)

export default component.exports